@if (showShaftOrder) {
	<div class="row mt-2">
		<div class="col-4">
			Shaft Order
		</div>
		<div class="col-8">
			<div class="form-check form-check-inline">
				<label>
					<input [ngModel]="shaftOrder" name="shaftOrder" type="radio" [value]="1" (ngModelChange)="setOrder($event)"> 1/rev
				</label>
			</div>
			<div class="form-check form-check-inline">
				<label>
					<input [ngModel]="shaftOrder" name="shaftOrder" type="radio" [value]="2" (ngModelChange)="setOrder($event)"> 2/rev
				</label>
			</div>
		</div>
	</div>
}
@if (showOneRev) {
	<div class="row mt-2">
		<div class="col-4">
			1/rev Only
		</div>
		<div class="col-8">
			<div class="form-check form-check-inline">
				<label>
					<input [ngModel]="oneRevOnly" type="checkbox" (ngModelChange)="setOneRev($event)">
				</label>
			</div>
		</div>
	</div>
}
